// src/components/modals/MaterialServiceSelectorModal.js
// Malzeme / Hizmet Seçici Modal - v4 Refactored

import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Tabs, Tab, Box, TextField, InputAdornment,
    Typography
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import InventoryIcon from '@mui/icons-material/Inventory';
import BuildIcon from '@mui/icons-material/Build';

// Modül import'ları
import {
    useMaterialSelector,
    StockTable,
    ServiceTable
    // SelectedItemPanel removed for multi-select
} from '../../modules/materials';

const TabPanel = ({ children, value, index }) => (
    <div role="tabpanel" hidden={value !== index}>
        {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
);

const MaterialServiceSelectorModal = ({ isOpen, onClose, onSelect }) => {
    const {
        currentTab,
        searchTerm,
        setSearchTerm,
        filteredStocks,
        filteredServices,
        selectedIds,
        toggleSelection,
        handleTabChange,
        validateAndPrepareItems,
        reset
    } = useMaterialSelector(isOpen);

    const handleAdd = () => {
        const result = validateAndPrepareItems();
        if (!result.valid) {
            alert(result.error);
            return;
        }
        onSelect(result.items);
        onClose();
    };

    const handleClose = () => {
        reset();
        onClose();
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <BuildIcon />
                    <Typography variant="h6">Malzeme / Hizmet Seç</Typography>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                {/* Tab Bar */}
                <Tabs
                    value={currentTab}
                    onChange={handleTabChange}
                    sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
                >
                    <Tab icon={<InventoryIcon />} label="Stoktan Ürün" iconPosition="start" />
                    <Tab icon={<BuildIcon />} label="Hizmetler" iconPosition="start" />
                </Tabs>

                {/* Arama */}
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder={currentTab === 0 ? "Ürün ara..." : "Hizmet ara..."}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{ mb: 2 }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />

                {/* Stoktan Ürün Sekmesi */}
                <TabPanel value={currentTab} index={0}>
                    <StockTable
                        stocks={filteredStocks}
                        selectedIds={selectedIds}
                        onToggle={toggleSelection}
                    />
                </TabPanel>

                {/* Hizmetler Sekmesi */}
                <TabPanel value={currentTab} index={1}>
                    <ServiceTable
                        services={filteredServices}
                        selectedIds={selectedIds}
                        onToggle={toggleSelection}
                    />
                </TabPanel>

                {/* Seçim Özeti */}
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <Typography variant="subtitle1">
                        {selectedIds.size} adet ürün/hizmet seçildi
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>İptal</Button>
                <Button
                    onClick={handleAdd}
                    variant="contained"
                    disabled={selectedIds.size === 0}
                    startIcon={<AddIcon />}
                >
                    Ekle ({selectedIds.size})
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MaterialServiceSelectorModal;
